// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__5QhJ-","footer":"ModalFilter_footer__1U7g6"};